/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useEffect, useState } from 'react'
import { Modal } from 'antd-mobile'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'
import useRootStore from '@store/useRootStore'

import { ModalBg, ModalTxt } from '@styles/base.style'
import { Button, ButtonWrap, PopupBtnStyle } from '@styles/button.style'
// css

const MissionCompletePopup: React.FC = () => {
  const { globalStore, userStore } = useRootStore()
  const { visibleMissionCompletePopup } = globalStore
  const [pickUpButtonDisabled, setPickUpButtonDisabled] = useState(false)

  const onClose = () => globalStore.setVisibleMissionCompletePopup(false)
  const onClickGoMission = () => {
    globalStore.setVisibleMissionCompletePopup(false)
    globalStore.setVisibleMissionListPopup(true)
  }
  const onClickPickUpAllMissionHandler = async () => {
    setPickUpButtonDisabled(true)
    await userStore.pickUpAllMissionReward()
    onClose()
  }

  useEffect(() => {
    if (!visibleMissionCompletePopup) {
      setPickUpButtonDisabled(false)
    }
  }, [visibleMissionCompletePopup])

  return (
    <Modal
      popup
      wrapClassName="mission-popup"
      visible={visibleMissionCompletePopup}
      maskClosable={false}
      animated={isMobile}
      animationType="slide-up"
      onClose={onClose}
      className="short-top"
    >
      <ModalTxt css={theme => ({ fontSize: theme.font.large })}>
        미션을 완료하였습니다.
        <br />
        미션 보상을 수령하시겠습니까?
      </ModalTxt>
      <ButtonWrap className="modal modal-bottom-btn">
        <Button
          primary
          onClick={onClickGoMission}
          className="two-button cancel bottom-btn primary"
          css={PopupBtnStyle}
        >
          미션 확인
        </Button>
        <Button
          disabled={pickUpButtonDisabled}
          css={PopupBtnStyle}
          onClick={onClickPickUpAllMissionHandler}
          className="two-button bottom-btn">
          예
        </Button>
      </ButtonWrap>
      <ModalBg />
    </Modal>
  )
}
export default observer(MissionCompletePopup)
